import { Color24, Colors24 } from '@grammarly/badger-ui'

interface WebinarProps {
  color?: Color24
}

export const CameraIcon = (props: WebinarProps) => {
  const { color = 'green60' } = props
  const svgColor = Colors24[color]
  return (
    <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.5 4.33333L15.294 2.43634C15.8481 2.1593 16.5 2.56221 16.5 3.18169V8.8183C16.5 9.43779 15.8481 9.8407 15.294 9.56366L11.5 7.66667M3.16667 11H9.83333C10.7538 11 11.5 10.2538 11.5 9.33333V2.66667C11.5 1.74619 10.7538 1 9.83333 1H3.16667C2.24619 1 1.5 1.74619 1.5 2.66667V9.33333C1.5 10.2538 2.24619 11 3.16667 11Z"
        stroke={svgColor}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}
